import { metaToConsts } from "@/shared/lib/meta-to-consts";
import { metaToMap } from "@/shared/lib/meta-to-map";
import type { ValueMeta } from "@/shared/model";

type ValidationErrorMeta = ValueMeta<string> & {
  description: string;
  message: string;
};

export const VALIDATION_ERROR_META = [
  {
    id: "VE01",
    name: "INVALID_PASSWORD",
    label: "비밀번호 형식 오류",
    value: "INVALID_PASSWORD",
    description: "비밀번호 형식이 정규식/스키마 검증을 통과하지 못함",
    message: "비밀번호 형식이 올바르지 않습니다.",
  },
  {
    id: "VE02",
    name: "DUPLICATE_EMAIL",
    label: "이메일 중복",
    value: "DUPLICATE_EMAIL",
    description: "이미 등록된 이메일 주소",
    message: "이미 사용 중인 이메일입니다.",
  },
  {
    id: "VE03",
    name: "DUPLICATE_NICKNAME",
    label: "닉네임 중복",
    value: "DUPLICATE_NICKNAME",
    description: "이미 등록된 닉네임",
    message: "이미 사용 중인 닉네임입니다.",
  },
  {
    id: "VE04",
    name: "INVALID_INPUT",
    label: "입력값 오류",
    value: "INVALID_INPUT",
    description: "입력값이 유효성 검사를 통과하지 못함",
    message: "입력 정보를 확인해 주세요.",
  },
  {
    id: "VE05",
    name: "SIGNUP_FAILED",
    label: "회원가입 실패",
    value: "SIGNUP_FAILED",
    description: "회원가입 요청 처리 실패",
    message: "회원가입에 실패했습니다. 입력 정보를 확인해 주세요.",
  },
] as const satisfies readonly ValidationErrorMeta[];

export const VALIDATION_ERROR_VALUE = metaToConsts(VALIDATION_ERROR_META);
export const VALIDATION_ERROR_MAP = metaToMap(VALIDATION_ERROR_META);
export type ValidationErrorId = (typeof VALIDATION_ERROR_META)[number]["id"];
